import { Typography } from '@mui/material';
import CustomBreadcrumbs from '../utils/CustomBreadcrumbs';
import Header from '../utils/Header';
import CustomSearchBar from '../utils/CustomSearchBar';
import SearchCards from '../utils/SearchCards';
import InternshipCard from './InternshipCard';
import InternshipsAPI from '../Apis/InternshipsAPI';
import toList from '../utils/ComponentUtil';
import { Link } from 'react-router-dom';

function InternshipsPage() {
    const breadcrumbs = [toList([{ to: "/", child: "Home" }], Link)
        , <Typography className="job-page-name">Internship</Typography>];

    return (
        <>
            <SearchCards
                selected='Work From Home'
                card={InternshipCard}
                api={InternshipsAPI.fetchInternships}
                heading={<div className='wrapper'><CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    <Header title=''></Header>
                    <CustomSearchBar placeholder='Search by names, locations, skills, jobs' /></div>}
            />
        </>
    );
}

export default InternshipsPage;